import { entity, like, query, string } from '~/prix'

export default function AgentFetchSelfQuery(cpf: string) {
  return query('legalEntityAttendanceAttendant')
    .select({
      hash: entity('legalEntityAttendanceAttendant').property('hash'),
      agentCpf: entity('legalEntityAttendanceAttendant').property('cpf'),
      name: entity('legalEntityAttendanceAttendant').property('coalesce'),
      order: entity('legalEntityAttendanceAttendant').property('name'),
      stateAbbreviation: entity('legalEntityAttendanceAttendant').property('stateAbbreviation'),
    })
    .where(like(entity('legalEntityAttendanceAttendant').property('cpf'), string().value(`${cpf}`)))
    .limit(1)
}
